/*
  Field Notes — article table of contents.
  Builds jump links from the H2s in the article body (plus the FAQ block's
  heading when the article has one), injects stable anchor
  ids, and highlights the current section on scroll. No dependencies.
*/
(function () {
  'use strict';

  function slugify(text, used) {
    var base = (text || '')
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
    if (!base) base = 'section';
    var slug = base;
    var n = 2;
    while (used[slug]) {
      slug = base + '-' + n;
      n += 1;
    }
    used[slug] = true;
    return slug;
  }

  function initToc(toc) {
    var contentSelector = toc.getAttribute('data-toc-content');
    var content = contentSelector ? document.querySelector(contentSelector) : null;
    var list = toc.querySelector('.fn-toc__list');
    if (!content || !list) {
      toc.hidden = true;
      return;
    }

    var labelMap = {};
    try {
      labelMap = JSON.parse(toc.getAttribute('data-toc-labels')) || {};
    } catch (e) {
      labelMap = {};
    }

    var headings = Array.prototype.slice.call(content.querySelectorAll('h2'));
    // The FAQ block renders outside the article body; it gets a jump link too.
    var faqTitle = document.querySelector('.article-template .fn-faq__title');
    if (faqTitle) headings.push(faqTitle);
    if (headings.length < 2) {
      // Not enough sections to justify a TOC.
      toc.hidden = true;
      return;
    }

    var used = {};
    var links = [];

    headings.forEach(function (heading) {
      if (!heading.id) {
        heading.id = slugify(heading.textContent, used);
      } else {
        used[heading.id] = true;
      }

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'fn-toc__link';
      a.href = '#' + heading.id;
      // TOC labels stay short: the custom.toc_labels metafield map wins
      // (Shopify strips data-* from rendered body HTML, so labels can't ride
      // the headings), else trim "Topic: elaboration" to the topic.
      var text = heading.textContent.trim();
      var label = labelMap[text] || heading.getAttribute('data-toc');
      if (!label) {
        label = text;
        var colon = label.indexOf(':');
        if (colon > 0) label = label.slice(0, colon).trim();
      }
      a.textContent = label;
      li.appendChild(a);
      list.appendChild(li);
      links.push({ link: a, id: heading.id });
    });

    toc.hidden = false;

    // Smooth-scroll without leaving a jumpy hash jump on browsers that honor it.
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      links.forEach(function (entry) {
        entry.link.addEventListener('click', function (event) {
          var target = document.getElementById(entry.id);
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', '#' + entry.id);
        });
      });
    }

    // Scroll-spy: highlight the heading nearest the top of the viewport.
    if ('IntersectionObserver' in window) {
      var byId = {};
      links.forEach(function (entry) {
        byId[entry.id] = entry.link;
      });

      var visible = {};
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            visible[entry.target.id] = entry.isIntersecting;
          });

          var current = null;
          headings.forEach(function (heading) {
            if (visible[heading.id] && !current) {
              current = heading.id;
            }
          });

          links.forEach(function (entry) {
            entry.link.classList.toggle('is-active', entry.id === current);
          });
        },
        { rootMargin: '-90px 0px -70% 0px', threshold: 0 }
      );

      headings.forEach(function (heading) {
        observer.observe(heading);
      });
    }
  }

  function init() {
    document.querySelectorAll('.fn-toc[data-toc-content]').forEach(initToc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
